import type { CalendarResource } from "../../../store/useCalendarStore";

export function resourceLabel(
  resources: CalendarResource[],
  resourceId: number,
): string {
  return resources.find((resource) => resource.id === resourceId)?.label ?? "";
}
